import { useAuth } from "context/AuthContext";
import { type ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import { AuthContext } from "../context/AuthContext";

interface IPublicRoute {
	children: ReactNode;
}

export function PublicRoute({ children }: IPublicRoute) {
	const location = useLocation();
	const navigate = useNavigate();
	const { isAuthenticated, isGameEnabled } = useAuth();

	useEffect(() => {
		if (!isGameEnabled && location.pathname !== "/locked") {
			navigate("/locked");
		}
	}, [isGameEnabled, location.pathname]);

	return <>{children}</>;
}
